import React from "react";
import { object, arrayOf, string, bool, shape } from "prop-types";
import { SocialShareButtons as SocialShareButtonsComponent } from "../../sharedComponents/SocialShareButtons";
import * as styles from "./SocialShareButtons.module.scss";

const defaultLabels = {
	publishedOn: "Published on",
	share: "share",
};

const SocialShareButtons = ({
	locale,
	location,
	displayDate,
	socialShareTitle,
	socialShareImage,
	displayFacebookLink,
	displayPinterestLink,
	displayTwitterLink,
	twitterHandle,
	twitterHashtags,
	variant,
	labels: providedLabels,
}) => {
	const labels = { ...defaultLabels, ...providedLabels };
	return (
		<SocialShareButtonsComponent
			locale={locale}
			displayDate={displayDate}
			socialShareTitle={socialShareTitle}
			socialShareImage={socialShareImage}
			displayFacebookLink={displayFacebookLink}
			displayPinterestLink={displayPinterestLink}
			displayTwitterLink={displayTwitterLink}
			twitterHandle={twitterHandle}
			twitterHashtags={twitterHashtags}
			location={location}
			styles={styles}
			variant={variant}
			labels={labels}
		/>
	);
};

SocialShareButtons.propTypes = {
	location: object,
	locale: string,
	displayDate: string,
	socialShareTitle: string,
	socialShareImage: shape({
		file: shape({
			url: string,
		}),
	}),
	displayFacebookLink: bool,
	displayPinterestLink: bool,
	displayTwitterLink: bool,
	twitterHandle: string,
	twitterHashtags: arrayOf(string),
	variant: string,
	labels: shape({ publishedOn: string }, { share: string }),
};
SocialShareButtons.defaultProps = {
	location: null,
	locale: null,
	displayDate: null,
	socialShareTitle: null,
	socialShareImage: null,
	displayFacebookLink: false,
	displayPinterestLink: false,
	displayTwitterLink: false,
	twitterHandle: "SunwingVacay",
	twitterHashtags: [],
	variant: "blog",
	labels: defaultLabels,
};

export default SocialShareButtons;
export { SocialShareButtons };
